module.exports = __webpack_public_path__ + "static/BB_Bourbon-61.f71e14bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_Bourbon-61.jpg
// module id = 447
// module chunks = 35783957827783